// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1_DiZ","colMin":"styles_colMin__2VmWH","colCheckbox":"styles_colCheckbox__3jk45"};